import { api } from "@/lib/api";
import type { VoiceEngines } from "@/lib/types";

/**
 * Whether the server's recogniser is live, known to stt.ts and nothing above it: components
 * ask for dictation and never learn whether whisper or the browser did it. The server's is
 * preferred; one that fails outright (not merely busy) is set aside for the rest of the
 * page, so the next try goes straight to the browser's.
 */

const NONE: VoiceEngines = { stt: false };
let cached: Promise<VoiceEngines | null> | null = null;
let known: VoiceEngines | null | undefined;
let sttDown = false;

/** The server's answer, fetched once per page; null when the call failed. */
export function loadEngines(): Promise<VoiceEngines | null> {
  cached ??= api
    .voiceEngines()
    .then((engines) => (known = { stt: Boolean(engines.stt) }))
    .catch(() => (known = null));
  return cached;
}

/** undefined until loaded, null when the call failed. */
export const loadedEngines = (): VoiceEngines | null | undefined => known;

export const knownEngines = (): VoiceEngines => known ?? NONE;

/** The server's recogniser is there and has not failed on this page. */
export const serverStt = (): boolean => knownEngines().stt && !sttDown;

export function markServerDown(): void {
  sttDown = true;
}
